import { Box, useTheme } from "@mui/material";
import { DateTime } from "luxon";
import * as React from "react";

import { AutorenewIcon } from "@/shared/foundation/icons/mui";

import { RobotoIconButton } from "../RobotoIconButton";
import { RobotoTooltip } from "../RobotoTooltip";
import { RobotoTypography } from "../RobotoTypography";

import { AISummaryFeedback } from "./AISummaryFeedback";
import styles from "./AISummaryMetadataBar.module.css";

interface AISummaryMetadataBarProps {
  created: string;
  onRegenerateClick: () => void;
  context: Record<string, unknown>;
  isRegenerating?: boolean;
}

export const AISummaryMetadataBar: React.FC<AISummaryMetadataBarProps> = ({
  created,
  onRegenerateClick,
  context,
  isRegenerating,
}) => {
  const theme = useTheme();

  const createdDate = DateTime.fromJSDate(new Date(created));
  const diffInSeconds = Math.abs(createdDate.diffNow("seconds").seconds);

  const relativeTime =
    diffInSeconds < 30 ? "a few moments ago" : createdDate.toRelative();

  return (
    <Box
      className={styles.metadataBar}
      sx={{ color: theme.palette.text.secondary }}
    >
      <RobotoTypography
        variant="body2"
        color="inherit"
        className={styles.createdText}
      >
        Generated {relativeTime}
      </RobotoTypography>

      <Box className={styles.actions}>
        <RobotoTooltip title="Regenerate">
          <span>
            <RobotoIconButton
              onClick={() => void onRegenerateClick()}
              eventName="RegenerateSummaryClicked"
              eventProperties={context}
              disabled={isRegenerating}
              className={isRegenerating ? styles.spinning : styles.iconButton}
            >
              <AutorenewIcon className={styles.renewIcon} />
            </RobotoIconButton>
          </span>
        </RobotoTooltip>
        <AISummaryFeedback context={context} />
      </Box>
    </Box>
  );
};
